import React from "react";
import { dummyPrivacy } from "../../components/policy/Policy";

// Import or define your HTML string here

const PrivacyPolicy = ({ contentType = "privacy" }) => {

  return (
    <div
      dangerouslySetInnerHTML={{ __html: dummyPrivacy }}
    />
  );
};

export default PrivacyPolicy;
